import _ from "lodash";

export const addMachine = (state, action) => {
  let list = state.list;
  const savedMachine = action.payload;

  return [savedMachine, ...list];
};

export const updateMachine = (state, action) => {
  let list = state.list;
  const updatedMachine = action.payload;

  const index = _.findIndex(list, ["id", updatedMachine.id]);
  list[index] = updatedMachine;

  return [...list];
};

export const removeMachine = (state, action) => {
  let list = state.list;
  const deletedMachineId = action.payload;

  const filteredList = _.filter(list, function (td) {
    return td.id !== deletedMachineId;
  });

  return [...filteredList];
};
export const formtValidationErrors = (validationErrors) => {
  const keys = Object.keys(validationErrors);
  const errors = [];

  keys.forEach((key) => {
    errors.push({
      name: key,
      errors: validationErrors[key],
    });
  });

  return errors;
};
